import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonsComponent } from '../../../shared/buttons/buttons.component';
import { ModalDialogComponent } from '../../../shared/modal-dialog/modal-dialog.component';
import { InputComponent } from '../../../shared/input/input.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SampleDetailsModal } from '../sample-details-modal';
import { MatInputModule } from '@angular/material/input';
import { noWhitespaceValidator } from '../../../shared/validators/no-whitespace.validator';

@Component({
  selector: 'app-sample-details-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    CommonModule,
    MatButtonModule,
    ButtonsComponent,
    InputComponent,
    ReactiveFormsModule,
    MatInputModule,
  ],
  templateUrl: './sample-details-modal.component.html',
  styleUrl: './sample-details-modal.component.css',
})
export class SampleDetailsModalComponent implements OnInit {
  btnStyleFilledSmallForPrimaryBtn = 'btn-filled-small';
  btnMatFlat: string = 'mat-flat-button';
  btnMat: string = 'mat-button';
  arialLabelCancel: string = 'Cancel';
  arialLabelCreateSample: string = 'Create Sample';
  btnStyleText: string = 'btn-text';
  textInputType = 'text';
  sampleDetailsForm: FormGroup = new FormGroup({});
  sampleName = new FormControl('', [Validators.required, Validators.maxLength(256), noWhitespaceValidator()]);
  sampleDescription = new FormControl('', [Validators.maxLength(1024), noWhitespaceValidator()]);
  btnStyleFilledSmallForPrimaryBtnDisabled = 'btn-filled-small-disabled';
  @Output() primaryAction = new EventEmitter<{ sampleName: string; sampleDescription: string }>();
  @Output() secondaryAction = new EventEmitter<void>();
  isErrorVisible: boolean = false;
  errorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SampleDetailsModal
  ) {}

  ngOnInit() {
    this.sampleDetailsFormInit();
  }

  onPrimaryAction(): void {
    this.sampleDetailsForm.markAllAsTouched();
    if (this.sampleDetailsForm.valid) {
      const formValues = this.sampleDetailsForm.value;
      const trimmedSampleName = (formValues.sampleName || '').trim();
      const trimmedSampleDescription = (formValues.sampleDescription || '').trim();
      this.primaryAction.emit({
        sampleName: trimmedSampleName,
        sampleDescription: trimmedSampleDescription,
      });
    }
  }

  onSecondaryAction(): void {
    this.secondaryAction.emit();
    this.dialogRef.close(false);
  }

  sampleDetailsFormInit() {
    this.sampleDetailsForm = new FormGroup({
      sampleName: this.sampleName,
      sampleDescription: this.sampleDescription,
    });
  }

  closeModal(result: boolean): void {
    this.dialogRef.close(result);
  }

  showError(message: string): void {
    this.isErrorVisible = true;
    this.errorMessage = message;
  }

  hideError(): void {
    this.isErrorVisible = false;
    this.errorMessage = '';
  }
}
